import React, { useEffect, useState, useRef } from 'react';
//import { ReactComponent as Smalllogo } from '../sclogo.svg';
import { LinearProgress } from '@mui/material';
import Header from './Header/Header';
import { Transition } from 'react-transition-group';


const TIMEOUT= 300

const getTransitionStyles = {
    entering: {
      position: `absolute`,

      opacity: 1,
      transform: `translateY(50px)`,
      position: 'fixed',
      width: '100%',
      height: '100%',
      background: 'white',
      zIndex: 10000,
      left: 0,
      top: 0,
    },
    entered: {
      transition: `opacity ${TIMEOUT}ms ease-in-out, transform ${TIMEOUT}ms ease-in-out`,
      opacity: 1,
      transform: `translateY(0px)`,
      animation: "blink .3s linear 2",
      position: 'fixed',
      width: '100%',
      height: '100%',
      background: 'white',
      zIndex: 10000,
      left: 0,
      top: 0,
    },
    exiting: {
      transition: `opacity ${TIMEOUT}ms ease-in-out, transform ${TIMEOUT}ms ease-in-out`,
      opacity: 0,
      position: 'fixed',
      width: '100%',
      height: '100%',
      background: 'white',
      zIndex: 10000,
      left: 0,
      top: 0,
    },
    exited: {
        transition: `opacity ${TIMEOUT}ms ease-in-out, transform ${TIMEOUT}ms ease-in-out`,
        opacity: 0,
        height: 0,
        display: 'none',
    }
  }



function Loading({isLoading,setDone}) {
    const nodeRef = useRef(null);
    useEffect(() => {
        if (isLoading === false) {
            setTimeout(() => {
                setDone(true);
            },TIMEOUT)
        }
    },[isLoading]);
    return <Transition
            timeout={{
                enter: 0,
                exit: TIMEOUT
            }}
            nodeRef={nodeRef}
            in={isLoading}

            appear={true}
        >
            {status => (
                <div
                    style={{...getTransitionStyles[status]}}
                    ref={nodeRef}
                    className={`loading-container ${status}`}
                >
                    <div style={{display: "flex", flexDirection: "column", justifyContent: "center", minHeight: "100vh", width: "100%", alignItems: "center"}}>
                        <Header />
                        <div style={{marginBottom: "2rem"}}/>
                        <LinearProgress style={{width: "50%"}} />
                    </div>
                </div>)}
        
    </Transition>
}

export default Loading;